import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  selectItem,
  printRequest,
  getXMLRequest,
  setReportType,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemRequest,
  deleteItemSuccess,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} = getReportActions();

const cancelCLORequest = createAction('cancelCLORequest');
const refreshPageRequest = createAction('refreshPageRequest');
const setShouldRefreshPage = createAction('setShouldRefreshPage');
const createReferenceRequest = createAction('createReferenceRequest');
const createReferenceSuccess = createAction('createReferenceSuccess');
const addCarrierRatesByReportRequest = createAction('addCarrierRatesByReportRequest');

export {
  // report
  setReports,
  selectItem,
  printRequest,
  getXMLRequest,
  setReportType,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemRequest,
  deleteItemSuccess,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  // report
  cancelCLORequest,
  refreshPageRequest,
  setShouldRefreshPage,
  createReferenceRequest,
  createReferenceSuccess,
  addCarrierRatesByReportRequest,
};
